import { render, staticRenderFns } from "./ArticleFavourite.vue?vue&type=template&id=12c18e96&scoped=true&"
import script from "./ArticleFavourite.vue?vue&type=script&lang=js&"
export * from "./ArticleFavourite.vue?vue&type=script&lang=js&"
import style0 from "./ArticleFavourite.vue?vue&type=style&index=0&id=12c18e96&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c18e96",
  null
  
)

export default component.exports